import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tmm',
  templateUrl: './tmm.component.html',
  styleUrls: ['./tmm.component.css']
})
export class TmmComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
